import { VerifyProvisionalRegistrationTokenMutation } from "@/generated/graphql";
import { graphql, HttpResponse } from "msw";

export const verifyProvisionalRegistrationTokenHandler =
  graphql.mutation<VerifyProvisionalRegistrationTokenMutation>(
    "verifyProvisionalRegistrationToken",
    ({ query, variables }) => {
      return HttpResponse.json({
        data: {
          verifyProvisionalRegistrationToken: {
            email: "mock_user@moneyforward.com",
            result: true,
          },
        },
      });
    }
  );
